/**
 * PATCH bond status via per-type update endpoints.
 */
export function getBondUpdateEndpoint(bondType, bondId) {
  const type = String(bondType || "").toLowerCase();
  switch (type) {
    case "blanket":
      return `/update-blanket-bond/${bondId}/`;
    case "guardianship":
      return `/update_guardianship_bond/${bondId}/`;
    case "probate":
      return `/update_probate_bond/${bondId}/`;
    case "trustee":
      return `/update_trustee_bond/${bondId}/`;
    case "va":
      return `/update_va_bond/${bondId}/`;
    default:
      return null;
  }
}

export function buildBondStatusPatchPayload(status) {
  return { bond_status: status };
}
